import type { SearchHit } from '@shared/types.ts';
import { IconCheck, IconClock, IconPartial } from './icons.tsx';

/**
 * Where something stands, as one mark on the artwork.
 *
 * THREE STATES, AND THEY ARE NOT THE SAME QUESTION. "We have it" is an
 * invitation to press play. "Somebody asked for it" is a promise, and the
 * useful part is that asking again would do nothing. "Some of it is here" is
 * the one people get wrong most — a series where six episodes exist and the
 * rest have not aired is neither available nor missing, and showing it as
 * either produces a complaint.
 *
 * SHAPE CARRIES THE MEANING, colour reinforces it. A tick is finished, a
 * clock is waiting, a half-filled disc is partway — legible with the colour
 * removed, which matters for the one man in twelve who cannot separate green
 * from amber and would otherwise see three identical dots.
 */
export function StatusBadge({ state }: { state: SearchHit['state'] }) {
  if (state === 'none') return null;

  const [cls, label, Icon] =
    state === 'available' ? ['have', 'In your library', IconCheck] as const
    : state === 'partial' ? ['partial', 'Partly here — more to come', IconPartial] as const
    : state === 'processing' ? ['wait', 'Downloading now', IconClock] as const
    : ['wait', 'Requested — not here yet', IconClock] as const;

  return (
    <span className={`status status-${cls}`} title={label} aria-label={label}>
      <Icon size={14} />
    </span>
  );
}
